import { FetchTransactionItemsParams } from 'api/transactions';
import { accountQueryKeys } from 'queries/account-query-keys';

const transactionItemQueryKeys = {
    all: (accountId: number) => [...accountQueryKeys.current(accountId), 'transaction-items'],
    campaigns: (accountId: number, campaignIds: number[]) => [
        ...transactionItemQueryKeys.all(accountId),
        'campaigns',
        campaignIds,
    ],
    filters: (accountId: number, meta: Omit<FetchTransactionItemsParams, 'accountId'> = {}) => {
        const { campaigns = [], ...restMeta } = meta;

        return [...transactionItemQueryKeys.campaigns(accountId, campaigns), restMeta];
    },
};

export { transactionItemQueryKeys };
